import BookletAffiSignature from './BookletAffiSignature.js';

export default class BookletAffi {

    constructor() {
        console.log("BookletAffi initialized");
        this.bindEvents();
        this.initializeSignature();
        this.initializeWaitingGenerationRefresh();
    }

    bindEvents() {
        this.handleAskAffiForm();
        this.handleNotAptCheckbox();
        this.handleValidateAffiForm();
    }

    initializeSignature() {
        console.log("Checking for yousign iframe...", $("#yousign-iframe").length);
        if($("#yousign-iframe").length > 0) {
            console.log("Yousign iframe found, initializing signature controller");
            this.signatureController = new BookletAffiSignature();
            this.signatureController.hideLoader();
        } else {
            console.log("No yousign iframe found");
        }
    }

    initializeWaitingGenerationRefresh() {
        const $waitingAlert = $('#waiting-generation-alert');
        const $waitingDownloadAlert = $('#affi-not-available-alert');
        if ($waitingAlert.length > 0 || $waitingDownloadAlert.length > 0) {
            this.refreshInterval = setInterval(() => {
                // Check if the elements still exist on the page
                const $currentWaitingAlert = $('#waiting-generation-alert');
                const $currentWaitingDownloadAlert = $('#affi-not-available-alert');
                
                if ($currentWaitingAlert.length > 0 || $currentWaitingDownloadAlert.length > 0) {
                    // Elements still exist, proceed with refresh
                    window.location.reload();
                } else {
                    // Elements have been removed, stop refreshing
                    console.log("Waiting elements removed from page, stopping refresh interval");
                    clearInterval(this.refreshInterval);
                    this.refreshInterval = null;
                }
            }, 10000); // Check every 10 seconds
        }
    }

    // Cleanup method to clear interval if needed
    destroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    handleAskAffiForm() {
        var self = this;
        var $form = $('#ask-affi-form');
        if ($form.length > 0) {
            $form.validate({
                ignore: [],
                rules: {
                    'alert[comment]': {
                        required: true,
                        minlength: 3,
                    }
                },
                messages: {
                    'alert[comment]': {
                        required: 'Commentaire requis',
                        minlength: 'Commentaire requis'
                    }
                },
                errorClass: 'is-invalid',
                errorElement: 'div',
                errorPlacement: function(error, element) {
                    console.log(error);
                    console.log(element);
                    console.log("----");
                    error.addClass('invalid-feedback');
                    error.insertAfter(element);
                }
            });

            $form.on('submit', function(event) {
                event.preventDefault();
                if (self.isAskAffiFormValid(this)) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
    }

    isAskAffiFormValid(form) {
        // Return the result of the validation
        return $(form).valid();
    }

    handleNotAptCheckbox() {
        const $checkbox = $('#not_apt_for_supervised_driving');
        if ($checkbox.length > 0) {
            // Gérer le changement initial
            this.toggleButtonsBasedOnCheckbox($checkbox);
            
            // Ajouter un écouteur d'événements pour les changements futurs
            $checkbox.on('change', () => {
                this.toggleButtonsBasedOnCheckbox($checkbox);
            });
        }
    }

    toggleButtonsBasedOnCheckbox($checkbox) {
        const $signAffiBtn = $('#sign-affi-btn');
        const $refuseCsBtn = $('#refuse-cs-btn');

        if ($checkbox.is(':checked')) {
            $signAffiBtn.addClass('d-none');
            $refuseCsBtn.removeClass('d-none');
        } else {
            $signAffiBtn.removeClass('d-none');
            $refuseCsBtn.addClass('d-none');
        }
    }

    handleValidateAffiForm() {
        var self = this;
        var $form = $('#validate-affi-form');
        console.log($form);
        if ($form.length > 0) {
            $form.validate({
                ignore: [],
                rules: {
                    'skill_booklet_supervised_driving[accompanist_full_name]': {
                        required: false 
                        /*function() {
                            // Requis seulement si la case "pas apte" n'est pas cochée (on signe l'AFFI)
                            return !$('#not_apt_for_supervised_driving').is(':checked');
                        
                        }*/,
                        minlength: 0
                    },
                    'skill_booklet_supervised_driving[comment]': {
                        required: false,
                        minlength: 0
                    }
                },
                messages: {
                    'skill_booklet_supervised_driving[accompanist_full_name]': {
                        required: 'Nom et prénom de l\'accompagnateur requis',
                        minlength: 'Nom et prénom de l\'accompagnateur (3 caractères minimum)'
                    },
                    'skill_booklet_supervised_driving[comment]': {
                        required: 'Commentaire requis',
                        minlength: 'Commentaire requis'
                    }
                },
                errorClass: 'is-invalid',
                errorElement: 'div',
                errorPlacement: function(error, element) {
                    console.log(error);
                    console.log(element);
                    console.log("----");
                    error.addClass('invalid-feedback');
                    error.insertAfter(element);
                }
            });

            $form.on('submit', function(event) {
                event.preventDefault();
                if (self.isValidateAffiFormValid(this)) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
    }

    isValidateAffiFormValid(form) {
        // Return the result of the validation
        return $(form).valid();
    }

}